import React from 'react';
import { Box } from '@mui/material';
import InfoIcon from 'assets/images/infoIcon.svg';
import type { TileBadge } from '../types';
import { formatCurrency } from 'utils';

export function renderTitleWithInfoIcon(label: string) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
      <span>{label}</span>
      <Box
        component="img"
        src={InfoIcon}
        alt=""
        aria-hidden="true"
        sx={{ width: 14, height: 14, display: 'block' }}
      />
    </Box>
  );
}

export function resolveVarianceBadge(variance: number): TileBadge {
  if (variance === 0) return 'MATCHED';
  return variance > 0 ? 'SURPLUS' : 'DEFICIT';
}

export function resolveScratcherBadge({
  revenueVariance,
  quantityVariance,
}: {
  revenueVariance: number;
  quantityVariance: number;
}): TileBadge {
  if (revenueVariance > 0) return 'SURPLUS';
  if (revenueVariance < 0 || quantityVariance !== 0) return 'DEFICIT';
  return 'MATCHED';
}

export function buildMissingTicketsSubtext({
  badge,
  quantityVariance,
}: {
  badge: TileBadge;
  quantityVariance: number;
}): React.ReactNode | undefined {
  const shouldShowMissingTickets = badge !== 'SURPLUS' && quantityVariance !== 0;
  if (!shouldShowMissingTickets) return undefined;

  const quantityAbs = Math.abs(quantityVariance);
  return (
    <Box sx={{ color: '#A0AEC0 !important', fontStyle: 'italic', fontSize: '13px', lineHeight: 1.1 }}>
      {quantityAbs} {quantityAbs === 1 ? 'ticket' : 'tickets'} missing
    </Box>
  );
}

export function buildFreeScratchersSubtext(amount: number, count: number) {
  return (
    <Box
      sx={{
        color: '#A0AEC0 !important',
        fontStyle: 'italic',
        fontSize: '12px',
        lineHeight: 1.1,
        whiteSpace: 'nowrap',
      }}
    >
      free scratchers {formatCurrency(amount)}({count})
    </Box>
  );
}

